import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Container } from '@scentregroup/ui'

import pagesHoc from '../../pages-hoc'
import ProductImageGallery from '../product-image-gallery'
import ProductDescription from '../product-description'
import withProduct from '../../../containers/with-product'
import withProductCategories from '../../../containers/with-product-categories'
import StockAvailability from '../stock-availability'
import ProductTitle from '../product-title'
import getProductStructuredData from '../../../helpers/get-product-structured-data'
import analyticsUtils from '../../../helpers/analytics-utils'
import generateTag from '../products-gallery/product-card/generate-tag'
import style from './index.module.scss'
import MoreProducts from './more-products'

export class ProductDetail extends Component {
  componentDidMount() {
    if (this.props.product) {
      this.pushDataLayer()
    }
  }

  shouldComponentUpdate(nextProps) {
    const currentId = this.props.product && this.props.product.objectId
    const nextId = nextProps.product && nextProps.product.objectId
    if (nextId !== undefined && currentId !== nextId) {
      return true
    }
    return false
  }

  componentDidUpdate() {
    this.pushDataLayer()
  }

  pushDataLayer() {
    const { product, categoriesHierarchy } = this.props

    const datalayer = {
      event: analyticsUtils.events.PRODUCTS_VIEW_PRODUCT,
      ecommerce: {
        detail: {
          products: [
            {
              name: product.name,
              id: product.objectId,
              category: categoriesHierarchy[0].name,
              brand: product.brand,
              price: (product.salePrice || product.price) / 100,
              position: 1,
              dimension79: product.retailer.retailerCode,
              dimension87: product.retailer.name,
            },
          ],
        },
      },
    }

    analyticsUtils.gaTagTracking(datalayer)
  }

  render() {
    const { product, categoriesHierarchy, related, history } = this.props

    if (product) {
      return (
        <React.Fragment>
          <Container centred type="large">
            <div className={style.productDetail}>
              <ProductTitle
                lastItemLink
                title={product.name}
                categoriesHierarchy={categoriesHierarchy}
              />
              <div className={style.row}>
                <div className={style.item}>
                  <ProductImageGallery
                    images={product.images}
                    tag={generateTag(product.price, product.salePrice)}
                    name={product.name}
                  />
                </div>
                <div className={style.item}>
                  <div className={style.productDescriptionContainer}>
                    <ProductDescription hasTitleLink product={product} />
                  </div>
                  <div className={style.stockAvailabilityContainer}>
                    <StockAvailability product={product} history={history} />
                  </div>
                </div>
              </div>
            </div>
          </Container>
          <MoreProducts
            products={related}
            retailerName={product.retailer.name}
            retailerCode={product.retailer.retailerCode}
          />
        </React.Fragment>
      )
    }
    return []
  }
}

ProductDetail.propTypes = {
  product: PropTypes.object,
  categoriesHierarchy: PropTypes.arrayOf(PropTypes.object),
  related: PropTypes.arrayOf(PropTypes.object),
  history: PropTypes.object,
}

const getMetaData = ({ product, categoriesHierarchy }) =>
  product
    ? {
        title: `${product.brand} ${product.name} | Westfield`,
        description: product.detailedDescription,
        schema: getProductStructuredData({
          name: product.name,
          sku: product.itemCode,
          brand: product.brand,
          category: categoriesHierarchy[0].name,
          priceCurrency: 'AUD',
          price: (product.salePrice || product.price) / 100,
          image: product.images[0],
        }),
      }
    : { title: 'Westfield' }

// Queries need to be composed in this order as the withProduct query puts the
// category in the props so that the withProductCategories call knows what to
// fetch
export default withProduct(
  withProductCategories(pagesHoc(ProductDetail, getMetaData))
)
